import React, { useEffect, useRef } from 'react';

// props:
// images: array of image src strings
// selectedIndex: number
// onClose: () => void
// onChange: (newIndex) => void

const ImageModal = ({ images = [], selectedIndex = 0, onClose, onChange }) => {
  const index = selectedIndex ?? 0;
  // Declare hooks unconditionally and guard inside effects so their order is stable
  const closeBtnRef = useRef(null);

  // Keyboard navigation handler: guard inside effect
  useEffect(() => {
    if (!images || images.length === 0) return;
    const handler = (e) => {
      if (e.key === 'ArrowLeft') onChange((index - 1 + images.length) % images.length);
      if (e.key === 'ArrowRight') onChange((index + 1) % images.length);
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [index, images.length, onChange, onClose]);

  // Focus the close button for accessibility when modal opens
  useEffect(() => {
    if (!images || images.length === 0) return;
    if (closeBtnRef.current) closeBtnRef.current.focus();
  }, [images.length, index]);

  if (!images || images.length === 0) return null;
  // Support images as strings or objects like { path } or { url }
  const getSrc = (item) => {
    if (!item) return '';
    if (typeof item === 'string') return item;
    if (typeof item === 'object') return item.path || item.url || item.src || '';
    return '';
  };
  const src = getSrc(images[index]);

  const goPrev = () => onChange((index - 1 + images.length) % images.length);
  const goNext = () => onChange((index + 1) % images.length);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
      <div className="relative flex items-center">
        <button onClick={goPrev} className="text-white text-3xl p-2 mr-4">‹</button>
        <div className="relative">
          <button
            ref={closeBtnRef}
            onClick={onClose}
            className="absolute -top-6 -right-6 bg-white text-black rounded-full w-8 h-8 flex items-center justify-center shadow-lg hover:bg-gray-200"
            aria-label="Fechar"
          >
            ✕
          </button>
          <img src={src} alt={`Imagem ${index + 1}`} className="max-w-[80vw] max-h-[80vh] rounded-lg border-4 border-white shadow-xl" />
          {/* Visible counter overlay */}
          <div className="absolute left-1/2 transform -translate-x-1/2 -bottom-10 bg-black bg-opacity-60 text-white text-sm px-3 py-1 rounded">
            {index + 1} / {images.length}
          </div>
        </div>
        <button onClick={goNext} className="text-white text-3xl p-2 ml-4">›</button>
      </div>
    </div>
  );
};

export default ImageModal;
